import React from 'react';
import { Zap, Cpu, Database, TrendingUp } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';

const iconMap = {
  zap: Zap,
  cpu: Cpu,
  database: Database,
  'trending-up': TrendingUp
};

const ValueProposition = () => {
  const { content } = useLanguage();
  const { valuePropositions, ui } = content;

  return (
    <section className="py-20 lg:py-32 bg-gradient-to-b from-black via-gray-950 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            {ui.valueProposition.title}
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            {ui.valueProposition.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {valuePropositions.map((item) => {
            const Icon = iconMap[item.icon];
            return (
              <div
                key={item.id}
                className="group relative bg-gradient-to-b from-gray-900 to-gray-950 border border-gray-800 rounded-2xl p-8 hover:border-blue-600/50 transition-all duration-300"
              >
                {/* Icon */}
                <div className="w-14 h-14 bg-blue-600/10 rounded-xl flex items-center justify-center mb-6 group-hover:bg-blue-600/20 transition-colors duration-300">
                  <Icon className="text-blue-400" size={28} />
                </div>

                {/* Content */}
                <h3 className="text-xl font-semibold text-white mb-3">
                  {item.title}
                </h3>
                <p className="text-gray-400 leading-relaxed">
                  {item.description}
                </p>

                {/* Hover glow */}
                <div className="absolute inset-0 bg-blue-600/5 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10"></div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ValueProposition;
